module.exports = __webpack_public_path__ + "static/service-banner-market-research-1b006c619256f688500b9d3e2af18785.jpeg";